import React, { FC } from 'react';

type FacebookProps = {
  /** The color of the icon. */
  color?: string;
};

const Facebook: FC<FacebookProps> = ({ color = 'currentColor' }) => (
  <svg height="100%" version="1.1" viewBox="0 0 169.2 300" width="100%" x="0px" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" xmlSpace="preserve" y="0px">
    <g>
      <path
        d="M47.6,104.1H13.1V150h34.4v137.7h57.4V150h41.8l4.1-45.9h-45.9V84.9c0-11,2.2-15.3,12.8-15.3h33.1V12.2h-43.7 c-41.3,0-59.6,18.2-59.6,53V104.1z"
        fill={color}
      />
    </g>
  </svg>

);

export default Facebook;
